export default __webpack_public_path__ + "static/meshmark-score-fa44c383da5e332fc7663b03ad22f3e3.webp";